import { batch } from 'react-redux';

// project imports
import gestopAPI from 'utils/gestopAPI';
import { dispatch } from 'store/index';
import { errorProcessor } from 'utils/processors';
import { tplFollowUpStepActions } from './slice';
import capabilities from './capabilities';

export const ApiTplFollowUpStepsGetCollection = async ({
    filters = [],
    orderBy = [],
    groupBy = [],
    page = 1,
    limit = 10,
    includeSafeDeleted = false,
    successCallback = () => {},
    errorCallback = () => {},
    updateStore = true,
    config = {}
}) => {
    if (capabilities.app.includes('loader')) {
        dispatch(tplFollowUpStepActions.startLoading());
    }

    await gestopAPI
        .post('tplmgmt/followupsteps/list', { filters, orderBy, groupBy, page, limit, includeSafeDeleted }, config)
        .then((response) =>
            batch(() => {
                if (updateStore) {
                    dispatch(tplFollowUpStepActions.setList(response?.data?.list));
                    dispatch(tplFollowUpStepActions.setCount(response?.data?.count));
                }
                if (capabilities.app.includes('loader')) {
                    dispatch(tplFollowUpStepActions.stopLoading());
                }
                if (typeof successCallback === 'function') {
                    successCallback(response?.data?.list);
                }
            })
        )
        .catch((error) =>
            batch(() => {
                const errorMsg = errorProcessor(error?.response?.data);

                if (capabilities.app.includes('loader')) {
                    dispatch(tplFollowUpStepActions.stopLoading());
                }
                if (capabilities.app.includes('error-logger')) {
                    dispatch(tplFollowUpStepActions.logError(errorMsg));
                }
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMsg);
                }
            })
        );
};

export const ApiTplFollowUpStepsCountCollection = async ({
    filters = [],
    includeSafeDeleted = false,
    successCallback = () => {},
    errorCallback = () => {},
    config = {}
}) => {
    await gestopAPI
        .post('tplmgmt/followupsteps/count', { filters, includeSafeDeleted }, config)
        .then((response) => {
            if (typeof successCallback === 'function') {
                successCallback(response?.data?.count);
            }
        })
        .catch((error) => {
            const errorMsg = errorProcessor(error?.response?.data);

            if (typeof errorCallback === 'function') {
                errorCallback(errorMsg);
            }
        });
};

export const ApiTplFollowUpStepsPostCollection = async ({
    data = {},
    successCallback = () => {},
    errorCallback = () => {},
    updateStore = true,
    config = {}
}) => {
    if (capabilities.app.includes('loader')) {
        dispatch(tplFollowUpStepActions.startLoading());
    }

    await gestopAPI
        .post('tplmgmt/followupsteps', data, config)
        .then((response) =>
            batch(() => {
                if (updateStore) {
                    dispatch(tplFollowUpStepActions.insertItems(response?.data));
                }
                if (capabilities.app.includes('loader')) {
                    dispatch(tplFollowUpStepActions.stopLoading());
                }
                if (typeof successCallback === 'function') {
                    successCallback(response?.data);
                }
            })
        )
        .catch((error) =>
            batch(() => {
                const errorMsg = errorProcessor(error?.response?.data);

                if (capabilities.app.includes('loader')) {
                    dispatch(tplFollowUpStepActions.stopLoading());
                }
                if (capabilities.app.includes('error-logger')) {
                    dispatch(tplFollowUpStepActions.logError(errorMsg));
                }
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMsg);
                }
            })
        );
};

export const ApiTplFollowUpStepsDeleteCollection = async ({
    ids = [],
    successCallback = () => {},
    errorCallback = () => {},
    updateStore = true,
    config = {}
}) => {
    if (capabilities.app.includes('loader')) {
        dispatch(tplFollowUpStepActions.startLoading());
    }

    await gestopAPI
        .post('tplmgmt/followupsteps/delete', ids, config)
        .then((response) =>
            batch(() => {
                if (updateStore) {
                    dispatch(tplFollowUpStepActions.deleteItems(response?.data));
                }
                if (capabilities.app.includes('loader')) {
                    dispatch(tplFollowUpStepActions.stopLoading());
                }
                if (typeof successCallback === 'function') {
                    successCallback(response?.data);
                }
            })
        )
        .catch((error) =>
            batch(() => {
                const errorMsg = errorProcessor(error?.response?.data);

                if (capabilities.app.includes('loader')) {
                    dispatch(tplFollowUpStepActions.stopLoading());
                }
                if (capabilities.app.includes('error-logger')) {
                    dispatch(tplFollowUpStepActions.logError(errorMsg));
                }
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMsg);
                }
            })
        );
};

export const ApiTplFollowUpStepsPutItem = async ({
    id,
    data = {},
    successCallback = () => {},
    errorCallback = () => {},
    updateStore = true,
    config = {}
}) => {
    if (capabilities.app.includes('loader')) {
        dispatch(tplFollowUpStepActions.startLoading());
    }

    await gestopAPI
        .put(`tplmgmt/followupsteps/${id}`, data, config)
        .then((response) =>
            batch(() => {
                if (updateStore) {
                    dispatch(tplFollowUpStepActions.updateItems(response?.data));
                }
                if (capabilities.app.includes('loader')) {
                    dispatch(tplFollowUpStepActions.stopLoading());
                }
                if (typeof successCallback === 'function') {
                    successCallback(response?.data);
                }
            })
        )
        .catch((error) =>
            batch(() => {
                const errorMsg = errorProcessor(error?.response?.data);

                if (capabilities.app.includes('loader')) {
                    dispatch(tplFollowUpStepActions.stopLoading());
                }
                if (capabilities.app.includes('error-logger')) {
                    dispatch(tplFollowUpStepActions.logError(errorMsg));
                }
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMsg);
                }
            })
        );
};

export const ApiTplFollowUpStepsPatchItem = async ({
    id,
    data = {},
    successCallback = () => {},
    errorCallback = () => {},
    updateStore = true,
    config = {}
}) => {
    if (capabilities.app.includes('loader')) {
        dispatch(tplFollowUpStepActions.startLoading());
    }

    await gestopAPI
        .patch(`tplmgmt/followupsteps/${id}`, data, {
            ...config,
            headers: { ...config?.headers, 'Content-Type': 'application/merge-patch+json' } // Specific content type for PATCH requests
        })
        .then((response) =>
            batch(() => {
                if (updateStore) {
                    dispatch(tplFollowUpStepActions.updateItems(response?.data));
                }
                if (capabilities.app.includes('loader')) {
                    dispatch(tplFollowUpStepActions.stopLoading());
                }
                if (typeof successCallback === 'function') {
                    successCallback(response?.data);
                }
            })
        )
        .catch((error) =>
            batch(() => {
                const errorMsg = errorProcessor(error?.response?.data);

                if (capabilities.app.includes('loader')) {
                    dispatch(tplFollowUpStepActions.stopLoading());
                }
                if (capabilities.app.includes('error-logger')) {
                    dispatch(tplFollowUpStepActions.logError(errorMsg));
                }
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMsg);
                }
            })
        );
};

export const ApiTplFollowUpStepsDeleteItem = async ({
    id,
    successCallback = () => {},
    errorCallback = () => {},
    updateStore = true,
    config = {}
}) => {
    if (capabilities.app.includes('loader')) {
        dispatch(tplFollowUpStepActions.startLoading());
    }

    await gestopAPI
        .delete(`tplmgmt/followupsteps/${id}`, config)
        .then((response) =>
            batch(() => {
                if (updateStore) {
                    dispatch(tplFollowUpStepActions.deleteItems(id));
                }
                if (capabilities.app.includes('loader')) {
                    dispatch(tplFollowUpStepActions.stopLoading());
                }
                if (typeof successCallback === 'function') {
                    successCallback(response?.data);
                }
            })
        )
        .catch((error) =>
            batch(() => {
                const errorMsg = errorProcessor(error?.response?.data);

                if (capabilities.app.includes('loader')) {
                    dispatch(tplFollowUpStepActions.stopLoading());
                }
                if (capabilities.app.includes('error-logger')) {
                    dispatch(tplFollowUpStepActions.logError(errorMsg));
                }
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMsg);
                }
            })
        );
};

export const ApiTplFollowUpStepsGetItem = async ({ id, successCallback = () => {}, errorCallback = () => {}, config = {} }) => {
    if (capabilities.app.includes('loader')) {
        dispatch(tplFollowUpStepActions.startLoading());
    }

    await gestopAPI
        .get(`tplmgmt/followupsteps/${id}`, config)
        .then((response) =>
            batch(() => {
                if (capabilities.app.includes('loader')) {
                    dispatch(tplFollowUpStepActions.stopLoading());
                }
                if (typeof successCallback === 'function') {
                    successCallback(response?.data);
                }
            })
        )
        .catch((error) =>
            batch(() => {
                const errorMsg = errorProcessor(error?.response?.data);

                if (capabilities.app.includes('loader')) {
                    dispatch(tplFollowUpStepActions.stopLoading());
                }
                if (capabilities.app.includes('error-logger')) {
                    dispatch(tplFollowUpStepActions.logError(errorMsg));
                }
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMsg);
                }
            })
        );
};
